import { getSubscriptionPackagesByRole } from '../data/subscriptionPackages';

/**
 * ตรวจสอบสิทธิ์เหรียญตาม Subscription Plan
 * @param {string} role - role ของผู้ใช้
 * @param {string} subscriptionKey - subscription plan key
 * @returns {object} สิทธิ์เหรียญ
 */
export const getCoinPermissions = (role, subscriptionKey) => {
  const packages = getSubscriptionPackagesByRole(role);
  const currentPackage = packages.find(pkg => pkg.key === subscriptionKey);
  
  if (!currentPackage) {
    return {
      monthlyBookings: 0,
      canBook: false,
      remainingBookings: 0,
      needsUpgrade: true
    };
  }

  return {
    monthlyBookings: currentPackage.features.monthlyBookings,
    canBook: currentPackage.features.monthlyBookings > 0,
    remainingBookings: currentPackage.features.monthlyBookings, // จะต้องคำนวณจาก booking history จริง
    needsUpgrade: false
  };
};

/**
 * ตรวจสอบว่าสามารถจองได้หรือไม่
 * @param {string} role - role ของผู้ใช้
 * @param {string} subscriptionKey - subscription plan key
 * @param {number} currentBookings - จำนวนการจองในเดือนนี้
 * @returns {object} สถานะการจอง
 */
export const canUserBook = (role, subscriptionKey, currentBookings = 0) => {
  const permissions = getCoinPermissions(role, subscriptionKey);
  
  if (permissions.monthlyBookings === -1) {
    // ไม่จำกัด
    return {
      canBook: true,
      reason: null,
      remainingBookings: -1
    };
  }
  
  if (currentBookings >= permissions.monthlyBookings) {
    return {
      canBook: false,
      reason: `คุณใช้สิทธิ์การจองครบแล้ว (${permissions.monthlyBookings} ครั้ง/เดือน)`,
      remainingBookings: 0
    };
  }
  
  return {
    canBook: true,
    reason: null,
    remainingBookings: permissions.monthlyBookings - currentBookings
  };
};

/**
 * ตรวจสอบว่าต้องซื้อเหรียญเพิ่มหรือไม่
 * @param {number} requiredCoins - เหรียญที่ต้องการ
 * @param {number} currentCoins - เหรียญที่มี
 * @param {string} role - role ของผู้ใช้
 * @param {string} subscriptionKey - subscription plan key
 * @returns {object} สถานะเหรียญ
 */
export const checkCoinRequirement = (requiredCoins, currentCoins, role, subscriptionKey) => {
  if (currentCoins >= requiredCoins) {
    return {
      hasEnoughCoins: true,
      needsPurchase: false,
      shortage: 0,
      message: null
    };
  }
  
  const shortage = requiredCoins - currentCoins;
  
  return {
    hasEnoughCoins: false,
    needsPurchase: true,
    shortage,
    message: `เหรียญไม่พอ! คุณมี ${currentCoins} เหรียญ แต่ต้องใช้ ${requiredCoins} เหรียญ (ขาด ${shortage} เหรียญ)`
  };
};

/**
 * แสดงข้อความแนะนำการอัพเกรด
 * @param {string} role - role ของผู้ใช้
 * @param {string} currentSubscription - subscription ปัจจุบัน
 * @returns {string} ข้อความแนะนำ
 */
export const getUpgradeMessage = (role, currentSubscription) => {
  const packages = getSubscriptionPackagesByRole(role);
  const currentPackage = packages.find(pkg => pkg.key === currentSubscription);
  const higherPackages = packages.filter(pkg => pkg.ranking > currentPackage.ranking);
  
  if (higherPackages.length === 0) {
    return 'คุณใช้แผนสูงสุดแล้ว';
  }
  
  const nextPackage = higherPackages[0];
  return `อัพเกรดเป็น ${nextPackage.name} เพื่อสิทธิ์การจองมากขึ้น (${nextPackage.features.monthlyBookings === -1 ? 'ไม่จำกัด' : nextPackage.features.monthlyBookings} ครั้ง/เดือน)`;
};









